// Functional, short-lived sign-in recovery context. No credentials or identifiers.
// Analytics consent still controls whether the eventual diagnostic is sent.
const KEY = 'instanttranscriber_oauth_recovery_v1';
const TTL = 15 * 60 * 1000;
let memory = null;

export function clearAuthFlow(browser = window) {
  memory = null;
  try { browser.sessionStorage.removeItem(KEY); } catch {}
}

export function rememberAuthFlow(method, redirectTo, browser = window) {
  if (!['google', 'apple'].includes(method)) return;
  if(typeof redirectTo!=='string'||!redirectTo){clearAuthFlow(browser);return;}
  try {
    const url = new URL(redirectTo, browser.location.href);
    const target = url.searchParams.get('auth_target') === 'signup' ? 'signup' : 'login';
    memory = { method, target, path: url.pathname, created: Date.now() };
    try { browser.sessionStorage.setItem(KEY, JSON.stringify(memory)); } catch {}
  } catch { clearAuthFlow(browser); }
}

export function readAuthFlow(browser = window) {
  let value;
  try { value = JSON.parse(browser.sessionStorage.getItem(KEY) || 'null') || memory; } catch { value = memory; }
  if (!value || !['google', 'apple'].includes(value.method) || !['signup', 'login'].includes(value.target)
      || !Number.isFinite(value.created) || value.created > Date.now() + 1000 || Date.now() - value.created > TTL
      || value.path !== new URL(browser.location.href).pathname) return null;
  return { method: value.method, target: value.target };
}
